"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorMarketplaceSearch = void 0;

var _api = _interopRequireDefault(require("../../http/api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendorMarketplaceSearch = function vendorMarketplaceSearch(inputVal, categoryId) {
  return _api.default.post('/web-marketplace-api/v1/vendor-search/list-by-category', {
    prefix: inputVal,
    category_id: categoryId
  });
};

exports.vendorMarketplaceSearch = vendorMarketplaceSearch;